export { default } from './TimelineConnector';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TimelineConnector/index.js
// module id = 895
// module chunks = 2